// src/modules/app-views/toolbox/pages/Document/tabs/SpecsTab/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Card, Col, Row } from 'antd';
import { ROW_GUTTER } from 'constants/ThemeConstant';
import translateX from 'utils/translateX';
import SimpleInput from 'components/SimpleComponents/SimpleInput';
import SimpleSelect from 'components/SimpleComponents/SimpleSelect';
import SimpleSwitch from 'components/SimpleComponents/SimpleSwitch';
import SimpleLoadingArea from 'components/SimpleComponents/SimpleLoadingArea';
import { useDocumentContext } from 'components/core/DocumentProvider';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const ToolboxSpecsTab = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { data, loading } = useDocumentContext() || {};

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const toolTypeOptions = [
    { value: 'manual', label: translateX('manual') },
    { value: 'electric', label: translateX('electric') },
    { value: 'pneumatic', label: translateX('pneumatic') },
    { value: 'hydraulic', label: translateX('hydraulic') },
    { value: 'electronic', label: translateX('electronic') },
    { value: 'measuring', label: translateX('measuring') },
    { value: 'diagnostic', label: translateX('diagnostic') },
    { value: 'software', label: translateX('software') },
    { value: 'other', label: translateX('other') },
  ];

  const powerTypeOptions = [
    { value: 'battery', label: translateX('battery') },
    { value: 'ac_power', label: translateX('ac_power') },
    { value: 'usb', label: 'USB' },
    { value: 'manual', label: translateX('manual') },
    { value: 'not_applicable', label: translateX('not_applicable') },
  ];

  const precisionOptions = [
    { value: 'high', label: translateX('high') },
    { value: 'medium', label: translateX('medium') },
    { value: 'low', label: translateX('low') },
    { value: 'not_applicable', label: translateX('not_applicable') },
  ];

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div className="container" style={{ position: 'relative', minHeight: 120 }}>
      <SimpleLoadingArea name="toolboxSpecs" isFetching={loading} data={data} />

      {/* SPECIFICATIONS CARD */}
      <Card title={<div className="text-muted">{translateX('specifications')}</div>}>
        <Row gutter={ROW_GUTTER}>
          <Col xs={24} sm={8}>
            <SimpleSelect
              name="toolType"
              label="tool_type"
              options={toolTypeOptions}
              allowClear
            />
          </Col>

          <Col xs={24} sm={8}>
            <SimpleSelect
              name="powerType"
              label="power_type"
              options={powerTypeOptions}
              allowClear
            />
          </Col>

          <Col xs={24} sm={8}>
            <SimpleSelect
              name="precision"
              label="precision"
              options={precisionOptions}
              allowClear
            />
          </Col>
        </Row>

        <Row gutter={ROW_GUTTER}>
          <Col xs={12} sm={6}>
            <SimpleSwitch name="esdSafe" label="esd_safe" />
          </Col>

          <Col xs={12} sm={6}>
            <SimpleSwitch name="isConsumable" label="consumable" />
          </Col>
        </Row>

        <Row gutter={ROW_GUTTER}>
          <Col xs={24}>
            <SimpleInput name="specifications" label="specifications" type="textarea" rows={6} />
          </Col>
        </Row>
      </Card>
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default ToolboxSpecsTab;

// *******************************************************************************
// HELPERS
// *******************************************************************************
